import { createButtonCellComponent } from "../../../../ButtonCell/fabrics/createComponentUtils";
import { createDisplayNameForButtonCellSchevronElement } from "../../../utils/getDisplayName";

export default createButtonCellComponent(
    createDisplayNameForButtonCellSchevronElement("ButtonInlineLabel"),
);
